export interface BlogPost {
  id: number;
  title: string;
  date: string;
  preview: string;
  content: string;
  tags: string[];
}

export const blogs: BlogPost[] = [
  {
    id: 1,
    title: "Getting Started with React and TypeScript",
    date: "2023-10-15",
    preview: "Why you should use TypeScript with React and how to set up your first project.",
    content: `
      <p>React and TypeScript are a powerful combination. By adding static typing to JavaScript, TypeScript helps catch errors early during development, improves code maintainability, and provides better developer tooling (like autocompletion).</p>

      <h3>Why TypeScript?</h3>
      <ul>
        <li><strong>Type Safety:</strong> catch bugs at compile time rather than runtime.</li>
        <li><strong>Better Refactoring:</strong> rename variables and functions with confidence.</li>
        <li><strong>Documentation:</strong> types serve as a form of self-documentation.</li>
      </ul>

      <h3>Setting up a project</h3>
      <p>The easiest way to get started is using Create React App with the template:</p>
      <code>npx create-react-app my-app --template typescript</code>

      <p>This command sets up a new React project with all the necessary TypeScript configurations.</p>
    `,
    tags: ["React", "TypeScript", "Web Development"],
  },
  {
    id: 2,
    title: "The Importance of Responsive Web Design",
    date: "2023-11-02",
    preview: "Ensuring your website looks great on all devices is crucial in the modern web.",
    content: `
      <p>Responsive web design is an approach to web design that makes web pages render well on a variety of devices and window or screen sizes. Content, design and performance are necessary across all devices to ensure usability and satisfaction.</p>

      <h3>Key Concepts</h3>
      <ul>
        <li><strong>Fluid Grids:</strong> designing in terms of proportions rather than pixels.</li>
        <li><strong>Flexible Images:</strong> images that scale within their containing elements.</li>
        <li><strong>Media Queries:</strong> applying different CSS styles based on device characteristics (like width).</li>
      </ul>

      <p>With more users accessing the web via mobile devices than desktops, a mobile-first approach is often recommended.</p>
    `,
    tags: ["CSS", "Design", "Responsive"],
  },
  {
    id: 3,
    title: "Understanding CSS Variables",
    date: "2023-11-20",
    preview: "How to use CSS Custom Properties to create maintainable and themable styles.",
    content: `
      <p>CSS Variables, or Custom Properties, are entities defined by CSS authors that contain specific values to be reused throughout a document. They are set using custom property notation (e.g., <strong>--main-color: black;</strong>) and are accessed using the <strong>var()</strong> function (e.g., <strong>color: var(--main-color);</strong>).</p>

      <h3>Benefits</h3>
      <ul>
        <li><strong>Maintainability:</strong> Change a color value in one place, and it propagates everywhere.</li>
        <li><strong>Theming:</strong> Easily implement dark/light modes by overriding variables.</li>
        <li><strong>Readability:</strong> Names like <em>--primary-brand-color</em> are more descriptive than hex codes.</li>
      </ul>

      <p>They follow the cascade and can be manipulated with JavaScript, making them incredibly powerful for dynamic styling.</p>
    `,
    tags: ["CSS", "Tips"],
  },
];
